/** 系统 T 区战队（不可在门店端编辑） */
export function isTAreaTeamName(name) {
  return !!(name && String(name).trim().endsWith('T区'))
}

/** 门店端：成员本月已有业绩时的提示 */
export const STORE_JSJ_LOCK_MSG = '该战队成员本月已有业绩，门店端不可修改，请联系管理端调整'

/** 门店端：系统 T 区战队不可操作时的提示 */
export const STORE_JSJ_T_AREA_LOCK_MSG = 'T区为系统战队，门店端不可修改'

/** 门店端不可编辑/删除时的原因说明 */
export function getTeamLockReason(team) {
  if (!team) return ''
  if (isTAreaTeamName(team.jsj)) return STORE_JSJ_T_AREA_LOCK_MSG
  if (team.hasMemberPerformance) return STORE_JSJ_LOCK_MSG
  return ''
}

/** 门店端是否允许编辑该战队 */
export function isTeamStoreEditable(team) {
  if (!team || isTAreaTeamName(team.jsj)) return false
  return !team.hasMemberPerformance
}

export function mapPractitionerFromUser(u) {
  return {
    id: u.id,
    name: u.realName || u.account || u.id
  }
}

export function mapDetailToTeam(listRow, detailRes) {
  const payload = detailRes?.data || detailRes || {}
  const jsj = payload.jsj || payload
  const members = payload.members || []
  const teamId = listRow?.id || jsj?.id || ''
  const teamName = listRow?.jsj || jsj?.jsj || ''
  const hasMemberPerformance = !!payload.hasMemberPerformance
  return {
    id: teamId,
    jsj: teamName,
    hasMemberPerformance,
    storeEditable: payload.storeEditable !== false && !hasMemberPerformance,
    members: (members || []).map((m, i) => ({
      relationId: m.id,
      userId: m.userId,
      userName: m.userName || '无',
      isLeader: Number(m.isLeader) === 1 ? 1 : 0,
      sortOrder: m.sortOrder || i + 1
    }))
  }
}

export function buildMembersPayload(selectedIds, leaderId, getMemberName) {
  const lid = leaderId || (selectedIds.length === 1 ? selectedIds[0] : '')
  return selectedIds.map((userId, i) => ({
    userId,
    userName: getMemberName(userId),
    isLeader: userId === lid ? 1 : 0,
    sortOrder: i + 1
  }))
}

/**
 * 编辑战队时同步成员：增删、顾问变更
 */
export async function syncTeamMembers(teamId, oldMembers, newMembers, api) {
  const oldMap = new Map((oldMembers || []).map(m => [m.userId, m]))
  const newMap = new Map((newMembers || []).map(m => [m.userId, m]))

  for (const [userId, old] of oldMap) {
    const neu = newMap.get(userId)
    if (!neu) {
      if (old.relationId) {
        await api.deleteJsjUserRelation({ id: old.relationId })
      }
      continue
    }
    if (Number(old.isLeader) !== Number(neu.isLeader) && old.relationId) {
      await api.deleteJsjUserRelation({ id: old.relationId })
      await api.addUserToJsj({
        jsjId: teamId,
        userId: neu.userId,
        userName: neu.userName,
        isLeader: neu.isLeader,
        sortOrder: neu.sortOrder,
        status: 'ACTIVE'
      })
    }
  }

  for (const [userId, neu] of newMap) {
    if (!oldMap.has(userId)) {
      await api.addUserToJsj({
        jsjId: teamId,
        userId: neu.userId,
        userName: neu.userName,
        isLeader: neu.isLeader,
        sortOrder: neu.sortOrder,
        status: 'ACTIVE'
      })
    }
  }
}
